import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  folderInfo: undefined,
  documentInfo: undefined,
  navigationInfo: undefined,
};

export const workspaceSlice = createSlice({
  name: "workspace",
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
    setFolderInfo: (state, action) => {
      state = { ...state, folderInfo: action.payload };
      return state;
    },
    setDocumentInfo: (state, action) => {
      state = { ...state, documentInfo: action.payload };
      return state;
    },
    setNavigationInfo: (state, action) => {
      state = { ...state, navigationInfo: action.payload };
      return state;
    },
  },
});

export const { reset, setFolderInfo, setDocumentInfo, setNavigationInfo } =
  workspaceSlice.actions;

export default workspaceSlice.reducer;
